import SlimSelect from 'slim-select'

const moduleName = 'customSelect';

export function customSelect() {

    Array.from(document.querySelectorAll('.js-select')).forEach((self) => {
        const placeholder = self.dataset.placeholder;
        const wrap = self.closest('.select-wrap');
        new SlimSelect({
            select: self,
            showSearch: false,
            placeholder: placeholder,
            beforeOpen: () => {
                if(wrap) wrap.classList.add('_opened');
            },
            beforeClose: function () {
                if(wrap) wrap.classList.remove('_opened');
            }
        })
    });

    Array.from(document.querySelectorAll('.js-multi-select')).forEach((self) => {
        const placeholder = self.dataset.placeholder;
        const wrap = self.closest('.select-wrap');
        new SlimSelect({
            select: self,
            showSearch: false,
            closeOnSelect: false,
            selectByGroup: true,
            placeholder: placeholder,
            beforeOpen: () => {
                if(wrap) wrap.classList.add('_opened');
            },
            beforeClose: function () {
                if(wrap) wrap.classList.remove('_opened');
            }
        })
    });

}
